import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "scroll-tree" }
const _hoisted_2 = { class: "trees" }
const _hoisted_3 = {
  key: 0,
  class: "tree-line"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "tree-line"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "tree-line"
}

import { ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { TreeItem, ThildrenItem } from '../types'
import { LmsCourseCategory } from '@/api/Models/CourseDetail'
import { useRoute } from 'vue-router'

// eslint-disable-next-line

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollTree',
  props: {
    data: {}
  },
  emits: ['onSelectTree'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "48a63c1e": (_unref(themeColor))
}))

const props = __props
const route = useRoute()
// const router = useRouter()
const isFold = ref(true)
const dataTree = ref(props.data)
// const defaultSelectedId = ref(props.defaultSelectedId)
const emits = __emit
const currentTree = ref<TreeItem | ThildrenItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  children: [],
  courseNum: '',
  count: '',
  hasChildren: 0
})
const currentChildren = ref<TreeItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  children: [],
  courseNum: '',
  count: '',
  hasChildren: 0
})
const themeColor = useThemeColor()
const onSelect = (treeItem: TreeItem, childrenItem?: ThildrenItem) => {
  if (!childrenItem && isFold.value) {
    treeItem.isOpen = !treeItem.isOpen
  }
  const _currentChildren = childrenItem || treeItem
  if (currentChildren.value.id === _currentChildren.id) {
    return
  }
  // router.replace({
  //   path: route.path,
  //   query: {
  //     category: _currentChildren.id
  //   }
  // })
  // defaultSelectedId.value = _currentChildren.id
  currentTree.value = treeItem
  currentChildren.value = _currentChildren
  emits('onSelectTree', currentChildren.value)
}

watch(
  () => props.data,
  (newValue) => {
    dataTree.value = newValue.map((item) => {
      return {
        ...item,
        isOpen: false
      }
    })
  },
  {
    deep: true,
    immediate: true
  }
)

const findItemById = (
  items: LmsCourseCategory[],
  id: string
): { treeItem: LmsCourseCategory; childrenItem?: LmsCourseCategory } | undefined => {
  for (const item of items) {
    if (item.id === id) {
      return { treeItem: item }
    }
    if (item.children) {
      const foundInChildren = findItemById(item.children, id)
      if (foundInChildren) {
        return { treeItem: item, childrenItem: foundInChildren.treeItem }
      }
    }
  }
  return undefined
}

watch(
  () => [route.query.category, dataTree.value],
  (newValue) => {
    if (newValue[0] && newValue[1]) {
      const foundItem = findItemById(newValue[1], newValue[0])
      if (foundItem) {
        onSelect(foundItem.treeItem, foundItem.childrenItem)
        if (foundItem.treeItem.parentId === '0') {
          foundItem.treeItem.isOpen = true
        } else {
          const parentItem = findItemById(newValue[1], foundItem.treeItem.parentId)
          if (parentItem) {
            parentItem.treeItem.isOpen = true
          }
        }
      }
    }
  },
  {
    immediate: true
  }
)

// watch(
//   () => dataTree.value,
//   (newValue) => {
//     if (defaultSelectedId.value) {
//       const foundItem = newValue.find((item) => item.id === defaultSelectedId.value)
//       foundItem && onSelect(foundItem as unknown as TreeItem)
//     }
//   }
// )

// onActivated(() => {
//   const category = route.query.category as string
//   // 如果当前选中的分类和默认选中的分类相同，则不进行操作
//   if (defaultSelectedId.value === category || !category) {
//     return
//   }
//   defaultSelectedId.value = category
//   const foundItem = dataTree.value.find((item) => item.id === category)
//   if (foundItem) {
//     onSelect(foundItem as unknown as TreeItem)
//   } else {
//     console.log('选择全部')
//     onSelect({
//       id: '',
//       name: '',
//       parentId: '',
//       categoryLevel: 0,
//       children: [],
//       courseNum: '',
//       count: '',
//       hasChildren: 0
//     })
//   }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tree", { white: !currentChildren.value.id }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          onSelect({
            id: '',
            name: '',
            parentId: '',
            categoryLevel: 0,
            children: [],
            courseNum: '',
            count: '',
            hasChildren: 0
          })
        ))
      }, [
        (!currentChildren.value.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["tree-name", { active: !currentChildren.value.id }])
        }, _toDisplayString(_ctx.$t('all')), 3)
      ], 2)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTree.value, (treeItem) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["trees", { white: treeItem.id === currentTree.value.id }]),
        key: treeItem.id
      }, [
        _createElementVNode("div", {
          class: "tree",
          onClick: ($event: any) => (onSelect(treeItem as unknown as TreeItem))
        }, [
          (treeItem.id === currentChildren.value.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["tree-name", { active: treeItem.id === currentChildren.value.id, tree_name_black: treeItem.id === currentTree.value.id }])
          }, _toDisplayString(treeItem.name), 3),
          (isFold.value && treeItem.children.length)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: _normalizeClass(["iconfont icon-shouqijiantou", treeItem.isOpen ? 'tree-right-open' : 'tree-right-close'])
              }, null, 2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4),
        (treeItem.isOpen || !isFold.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(treeItem.children, (childrenItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tree",
                key: childrenItem.id,
                onClick: ($event: any) => (onSelect(treeItem as unknown as ThildrenItem, childrenItem as unknown as ThildrenItem))
              }, [
                (childrenItem.id === currentChildren.value.id && !isFold.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["tree-children-name", { active: childrenItem.id === currentChildren.value.id }])
                }, _toDisplayString(childrenItem.name), 3)
              ], 8, _hoisted_6))
            }), 128))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})